import { apiWrapper } from 'ccs-ui-components';
import { call, fork, put, takeLatest } from 'redux-saga/effects';
import { IQueryParamsUpdated } from '../../../models/common/IQueryParamsUpdated';
import { journeyListSchema } from '../../../utilities/sources/RegistriesSchemaDefintion';
import { fetchJourneyList } from '../../actions/actionType/sources/JourneyListActionTypes';
import { clearAllJourneys, fetchAllJourneysFailure, getAllJourneysStarted, getAllJourneysSuccess } from '../../actions/sagaActions/sources/GetAllJourneysSagaActions';
import { FetchAllJourneysFailurePayload, FetchAllJourneysRequest, IActiveJourney } from '../../actions/types/sources/GetAllJourneys';

const headersInstance = () => ({
  'Ocp-Apim-Subscription-Key':
    process.env.REACT_APP_API_OCP_APIM_SUBSCRIPTION_KEY ?? ''
});
/**
 * Call Gets Journeys by API
 * @returns api response
 */
export async function callGetAllJourneysApi(pageNo: number, item: number, queryParams?: IQueryParamsUpdated, sort?: string) {
  const urlString = `${process.env.REACT_APP_API_CONTROL_PLANE_SOURCE_REGISTRY_URL}/journeys/search?page=${pageNo}&size=${item}&sort=${sort ?? 'DESC'}`;
  const requestBody = queryParams ? {
    search: queryParams.searchText,
    statusList: ['Active'],
    fromDate: queryParams.fromDate ? (queryParams.fromDate) : '',
    toDate: queryParams.toDate ? (queryParams.toDate) : '',
  } : {};
  return apiWrapper.post<IActiveJourney>(
    urlString,
    requestBody,
    headersInstance()
  );
}

export function* getAllJourneys({ pageNo, item, queryParams, sort }: FetchAllJourneysRequest): any {
  yield put(clearAllJourneys());
  yield put(getAllJourneysStarted());
  try {
    const { responseBody: data, isError, error, statusCode } = yield call(callGetAllJourneysApi, pageNo, item, queryParams, sort);
    if (isError) {
      throw error;
    }
    const reqValidity = journeyListSchema.validate(data, { abortEarly: true });
    if (data) {
      const payloadData = {
        journeyList: data,
        statusCode: String(statusCode)
      };
      if (reqValidity.error) {
        throw new Error('No Response');
      } else {
        yield put(getAllJourneysSuccess(payloadData));
      }
    } else if (statusCode === 204) {
      const obj: FetchAllJourneysFailurePayload = {
        error: String('No data'),
        statusCode: String(statusCode)
      };
      yield put(fetchAllJourneysFailure(obj));
    }
  } catch (error) {
    const obj: FetchAllJourneysFailurePayload = {
      error: String(error)
    };
    yield put(fetchAllJourneysFailure(obj));
  }
}

/**
 * Saga Effect to consider latest request
 */
export function* fetchAllJourneysSaga() {
  yield takeLatest(fetchJourneyList.FETCH_JOURNEY_LIST_REQUEST, getAllJourneys);
}

export const getAllJourneysSaga = [fork(fetchAllJourneysSaga)];
